import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        name: 'Home',
        theme: null,
        nav: 'home'
      }
    },
    {
      path: '/about/:group?',
      name: 'about',
      component: () => import('./views/About.vue'),
      meta: {
        name: 'About Us',
        theme: '#6a0136',
        nav: 'about'
      },
      beforeEnter: (to, from, next) => {
        if ([undefined, 'choir', 'conductors', 'exco', 'coordinators'].includes(to.params.group)) {
          next()
        } else { next('/error') }
      }
    },
    {
      path: '/yearplan',
      name: 'year-plan',
      component: () => import('./views/Yearplan.vue'),
      meta: {
        name: 'Year Plan',
        theme: '#5f634f',
        nav: 'yearplan'
      }
    },
    {
      path: '/archive/news',
      name: 'news',
      component: () => import('./views/archive/News.vue'),
      meta: {
        name: 'News Archive',
        theme: '#313e50',
        nav: 'archive',
        section: 'Archive'
      }
    },
    {
      path: '/archive/news/session/:session',
      name: 'session-news',
      component: () => import('./views/archive/News.vue'),
      meta: {
        name: 'News Archive',
        theme: '#313e50',
        nav: 'archive',
        section: 'Archive'
      }
    },
    {
      path: '/archive/news/:id/:title?',
      name: 'news-article',
      component: () => import('./views/archive/Article.vue'),
      meta: {
        name: 'News Archive',
        theme: '#313e50',
        nav: 'archive',
        section: 'Archive'
      }
    },
    {
      path: '/archive/gallery',
      name: 'gallery',
      component: () => import('./views/archive/Gallery.vue'),
      meta: {
        name: 'Gallery',
        theme: '#313e50',
        nav: 'archive',
        section: 'Archive'
      }
    },
    {
      path: '/archive/events',
      name: 'archive',
      component: () => import('./views/archive/Event.vue'),
      meta: {
        name: 'Past Events',
        theme: '#313e50',
        nav: 'archive',
        section: 'Archive'
      }
    },
    {
      path: '/resources',
      name: 'resources',
      component: () => import('./views/Resources.vue'),
      meta: {
        name: 'Resources',
        theme: '#433A3F',
        nav: 'resources'
      }
    },
    {
      path: '/links',
      name: 'links',
      component: () => import('./views/Links.vue'),
      meta: {
        name: 'Links',
        theme: '#048A81',
        nav: 'links'
      }
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('./views/Contact.vue'),
      meta: {
        name: 'Contact Us',
        theme: '#e65145',
        nav: 'contact'
      }
    },
    {
      path: '/member'
    },
    {
      path: '/error'
    },
    {
      path: '*',
      beforeEnter () { location.replace('/error') }
    }
  ],
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})
